<template>
  <div class="columns is-align-items-center">
    <div class="column is-narrow">
      <qd-button
        type="button"
        class="button is-primary has-text-centered"
        :loading="loading"
        :disabled="loading"
        :class="{ 'text-access-no-permission': !checkPermissions(permissions)}"
        @click="checkPermissions(permissions) ? confirm() : showPopUp()">
        {{ label }}
      </qd-button>
    </div>
    <div class="column is-narrow columns is-align-items-center">
      <qd-icon
        v-if="!loading && isClicked"
        :type="hasError ? 'is-danger' : 'is-success'"
        :icon="hasError ? 'close-circle' : 'check-circle'"/>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';

const permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    permissions: {
      type: Object,
      required: true,
    },
    query: {
      type: Function,
      required: true,
    },
    successMessage: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      isClicked: false,
      hasError: false,
    };
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async confirm() {
      this.isClicked = true;
      this.loading = true;
      this.hasError = false;
      try {
        await this.query();
        if (this.successMessage) messageSucces(this.successMessage);
        this.$emit('done');
      } catch (e) {
        this.hasError = true;
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>

</style>
